import { render, staticRenderFns } from "./CatalogProductSettingCustomQuantities.vue?vue&type=template&id=92ddb914&scoped=true&"
import script from "./CatalogProductSettingCustomQuantities.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingCustomQuantities.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingCustomQuantities.vue?vue&type=style&index=0&id=92ddb914&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ddb914",
  null
  
)

export default component.exports